import Button from "@material-ui/core/Button";
import Alert from "@mui/material/Alert";
import { useSnackbar } from "notistack";
// External library import
import queryString from "query-string";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { sendActionToAdobeAnalytics } from "../../common/analytics/adobeanalytics/adobeanalytics";
import { AUTH_CONFIG } from "../../common/configs/auth.config";
import {
  appConstants,
  ENVIRONMENT,
  SNACKBAR_TYPE,
} from "../../common/constants/constants";
// userdefined component import
import Loader from "../../common/dialogs/loader/loader";
import { getTokenId } from "../../common/services/authService";
import { generatePKCE } from "../../common/utils/pkceUtils";
import { checkadmin } from "../../common/services/herdAccess.service";
import NetworkService from "../../common/services/networkService";
//constant,service,utility import
import { getEnvironment } from "../../common/utils";

const LoginScreen = (props) => {
  const history = useHistory();
  const [authCode, setAuthCode] = React.useState();
  const [errorMsg, setErrorMsg] = React.useState("");
  const { enqueueSnackbar } = useSnackbar();

  const EnvFlag = getEnvironment();
  let logoENV = "";
  if (EnvFlag === ENVIRONMENT.PROD) {
    logoENV = "";
  } else if (EnvFlag === ENVIRONMENT.QA) {
    logoENV = "-qa";
  } else if (EnvFlag === ENVIRONMENT.DEV) {
    logoENV = "-dev";
  } else {
    logoENV = "-local";
  }

  useEffect(() => {
    let code = getAuthCode(props);
    if (code) {
      setAuthCode(code);
      enqueueSnackbar("Logging in, please wait...", {
        anchorOrigin: { vertical: "top", horizontal: "center" },
        variant: SNACKBAR_TYPE.DEFAULT,
      });

      getTokenId(code, appConstants.Internal).then(
        (response) => {
          // Remove auth code from browser history after successful login
          window.history.replaceState({}, document.title, "/");
          NetworkService.setAccessTokenAuthHeader(response);
          localStorage.setItem(
            appConstants.LoginSessionKey,
            JSON.stringify(response),
          );
          checkadmin().then((response) => {
            if (["Administrator", "User"].includes(response)) {
              let jwt = JSON.parse(
                atob(
                  JSON.parse(
                    localStorage.getItem("LoginSessionKey"),
                  ).access_token.split(".")[1],
                ),
              );
              sendActionToAdobeAnalytics("login", {
                user: { userId: jwt.userid, userType: response },
              });
              localStorage.setItem(
                appConstants.UserInfo,
                JSON.stringify({
                  userId: jwt.mail,
                  userType: appConstants.Internal,
                }),
              );
              enqueueSnackbar("Login Successfully!!", {
                anchorOrigin: { vertical: "top", horizontal: "center" },
                variant: SNACKBAR_TYPE.SUCCESS,
              });
              history.push("/dashboard/herds");
            } else {
              enqueueSnackbar(
                "You are not an authorized user of this system.  Please request access.",
                {
                  anchorOrigin: { vertical: "top", horizontal: "center" },
                  persist: true,
                  variant: SNACKBAR_TYPE.ERROR,
                },
              );
              localStorage.clear();
              setAuthCode(false);
              history.push("/login");
            }
          });
        },
        (error) => {
          setErrorMsg(
            "Error: " +
              error.response.data.error +
              "\n Error Description: " +
              error.response.data.error_description +
              "\n Status Code: " +
              error.response.status,
          );
        },
      );
    }
  }, [history, props, enqueueSnackbar]);

  /**
   * Method will return auth code coming from server.
   * @param {*} props
   */
  function getAuthCode(props) {
    console.log("props in getAuthCode", props);
    if (props) {
      let params = queryString.parse(props.location.search);

      // Validate state parameter for CSRF protection
      const returnedState = params.state;
      const storedState = sessionStorage.getItem("oauth_state");

      if (returnedState && storedState && returnedState === storedState) {
        // State is valid, clean up
        sessionStorage.removeItem("oauth_state");
        return params.code;
      } else if (!returnedState) {
        // No state in callback (might be old flow or error)
        console.warn("No state parameter in OAuth callback");
        return params.code;
      } else {
        // State mismatch - possible CSRF attack
        console.error("OAuth state mismatch - possible CSRF attack");
        return null;
      }
    }
  }

  /**
   * SSO login
   */
  const ssoLogin = async () => {
    const ENV = getEnvironment();
    let REDIRECT_URI = AUTH_CONFIG.REDIRECT_URI_LOCAL;
    if (ENV === ENVIRONMENT.PROD) {
      REDIRECT_URI = AUTH_CONFIG.REDIRECT_URI_PROD;
      logoENV = "";
    } else if (ENV === ENVIRONMENT.QA) {
      REDIRECT_URI = AUTH_CONFIG.REDIRECT_URI_QA;
      logoENV = "-qa";
    } else if (ENV === ENVIRONMENT.DEV) {
      REDIRECT_URI = AUTH_CONFIG.REDIRECT_URI_DEV;
      logoENV = "-dev";
    }

    // PKCE logic for internal login
    const pkce = await generatePKCE();
    sessionStorage.setItem("pkce_code_verifier", pkce.codeVerifier);

    // Generate state parameter for CSRF protection
    const { generateState } = await import("../../common/utils/pkceUtils");
    const state = generateState();
    sessionStorage.setItem("oauth_state", state);

    const url =
      `${AUTH_CONFIG.AUTHORIZATION}?response_type=${AUTH_CONFIG.RESPONSE_TYPE}` +
      `&client_id=${AUTH_CONFIG.CLIENT_ID}` +
      `&redirect_uri=${REDIRECT_URI}` +
      `&scope=${AUTH_CONFIG.SCOPE}%20profile%20email` +
      `&code_challenge=${pkce.codeChallenge}` +
      `&code_challenge_method=S256` +
      `&state=${state}`;
    window.open(url, "_self");
  };

  return (
    <div className="login-container">
      <div className="login-form-container">
        <div className="login-form">
          <i className={"ag-icon logo ag-icon-benchmark-logo" + logoENV}></i>
          {authCode ? (
            <Loader radius={20} type="small" />
          ) : (
            <>
              <Button onClick={ssoLogin} variant="contained" disableElevation>
                Land O'Lakes Sign In
              </Button>
            </>
          )}
          {errorMsg && (
            <Alert className="alert-error" severity="warning">
              {errorMsg}
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
